import { NavItemType } from "./Nav";

export const navItems: NavItemType[] = [
  {
    title: "Who we are",
    description:
      "We’re a team of finance and auto industry professionals who believe in the power of free markets. We create market based solutions for new asset classes.",
    url: "/who-we-are",
    children: [
      {
        title: "Our mission",
        description: "Working to accelerate transformation",
        url: "/who-we-are/our-mission",
      },
      {
        title: "Our team",
        description: "Driven by innovation and collaboration",
        url: "/who-we-are/our-team",
      },
      {
        title: "Our advisory board",
        description: "Fortified by experience",
        url: "/who-we-are/our-board",
      },
    ],
  },
  {
    title: "Solutions",
    description:
      "We create new ecosystems around established derivatives to protect against growing market volatility in a changing automotive landscape.",
    url: "/solutions",
    children: [
      {
        title: "EM automotive indices",
        description: "Trusted benchmarks for the automotive industry",
        url: "/solutions/indices",
      },
      {
        title: "EM used vehicle derivatives",
        description: "Automotive as a new asset class",
        url: "/solutions/derivatives",
      },
      {
        title: "On the horizon",
        description: "Financial innovation for new markets",
        url: "/solutions/on-the-horizon",
      },
      {
        title: "EM index administration",
        description: "Our methodologies, data sources and index facts",
        url: "/governance/index-facts",
      },
    ],
  },
  {
    title: "Our clients",
    description:
      "We work with Automotive Manufacturers, Rental Car Companies, Auto Insurers, Subprime Lenders and Financial Firms to bring stability and opportunity to the evolving automotive industry.",
    url: "/our-clients",
    children: [
      {
        title: "Automotive manufacturers",
        description: "Capital efficient asset risk management solutions",
        description2: "Future-proof your asset exposure",
        url: "/our-clients/automotive-manufacturers",
      },
      {
        title: "Rental car companies",
        description: "Effectively managing asset exposure",
        description2: "Find solid ground in a changing landscape",
        url: "/our-clients/rental-car-companies",
      },
      {
        title: "Auto insurers",
        description: "Solutions to manage vehicle price volatility",
        description2: "Risk mitigation for turbulent times",
        url: "/our-clients/auto-insurers",
      },
      {
        title: "Subprime lenders",
        description: "Derivative hedging strategies",
        description2: "A reliable way to manage price volatility",
        url: "/our-clients/subprime-lenders",
      },
      {
        title: "Financial firms",
        description: "Gain directional exposure to a new asset class",
        description2: "Access an entirely new market",
        url: "/our-clients/financial-firms",
      },
    ],
  },

  {
    title: "In the press",
    description:
      "Content to help you navigate a changing financial landscape including recent press releases and our blog.",
    url: "/in-the-press",
    children: [
      {
        title: "Press releases",
        description: "Company news, awards and media resources",
        url: "/in-the-press/press-releases",
      },
      {
        title: "Blog",
        description: "Learn more about our solutions and industry",
        url: "/in-the-press/blog",
      },
    ],
  },
  {
    title: "Education",
    description:
      "Your learning hub for everything related to automotive finance from derivatives to indices.",
    url: "/education",
    children: [
      {
        title: "Indices",
        description: "Utilizing market indices",
        url: "/education/indices",
      },
      {
        title: "Derivatives",
        description: "Working with derivatives",
        url: "/education/derivatives",
      },
    ],
  },
  {
    title: "Governance",
    description: "",
    url: "/governance",
    isHeaderItem: false,
    children: [
      {
        title: "Documentation",
        description: "",
        url: "/governance/documentation",
      },
      {
        title: "Index facts",
        description: "",
        url: "/governance/index-facts",
      },
    ],
  },
  {
    title: "Contact us",
    description: "",
    url: "/contact-us",
    children: [
      {
        title: "Contact",
        description:
          "Get in touch with Exponential Markets to learn more about working with us.",
        url: "/contact-us/contact",
      },
    ],
  },
];
